module.exports = __webpack_public_path__ + "img/cross.34e910e7.svg";